import React, { useEffect, useRef, useState } from 'react';

export const DataCollectionScroll = ({ cardData, images }) => {
    const leftRefs = useRef([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const stackRef = useRef(null);
    const rotateCardsRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        if (!stackRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsInView(entry.isIntersecting);
            },
            {
                threshold: 0.2, // 20% visible = in view
            }
        );

        observer.observe(stackRef.current);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        setActiveIndex(0);
    }, []);

    useEffect(() => {
        const cards = document.querySelectorAll('.cdCard');
        const stackArea = document.querySelector('.cd-stack-area');

        function rotateCards(activeIndex) {
            let angle = 0;
            let rotate = 50;
            let leftRight = 50;

            cards.forEach((card, i) => {
                if (i < activeIndex) {
                    card.style.opacity = 0;
                    card.style.transform = 'translate(-50%, -120vh) rotate(-48deg)';
                } else {
                    card.style.opacity = 1;
                    card.style.transform = `translate(-${leftRight}%, -${rotate}%) rotate(${angle}deg)`;
                    angle -= 3;
                    rotate -= 3;
                    leftRight += 3;
                }
            });
        }

        // function rotateCards() {
        //     let angle = 0;
        //     let rotate = 50;
        //     let leftRight = 50;
        //     cards.forEach((card) => {
        //         if (card.classList.contains('cdActive')) {
        //             card.style.opacity = 0;
        //         } else {
        //             card.style.opacity = 1;
        //             card.style.transform = `translate(-${leftRight}%, -${rotate}%) rotate(${angle}deg)`;
        //             angle -= 3;
        //             rotate -= 3;
        //             leftRight += 3;
        //         }
        //     });
        // }

        rotateCardsRef.current = rotateCards;
        rotateCards(0);

        const handleScroll = () => {
            const stackArea = document.querySelector('.cd-stack-area');
            const cards = document.querySelectorAll('.cdCard');

            const rect = stackArea.getBoundingClientRect();
            const progress = Math.min(Math.max(-rect.top / window.innerHeight, 0), 1);

            const n = cards.length;
            const index = Math.floor(progress * n);

            cards.forEach((card, i) => {
                if (i < index) {
                    card.classList.add('cdActive');
                } else {
                    card.classList.remove('cdActive');
                }
            });

            setActiveIndex(index);
            rotateCards(index);
        };

        // const handleScroll = () => {
        //     const stackArea = document.querySelector('.cd-stack-area');
        //     const cards = document.querySelectorAll('.cdCard');
        //     let proportion = stackArea.getBoundingClientRect().top / window.innerHeight;
        //
        //     if (proportion <= 0) {
        //         let n = cards.length;
        //         let index = Math.ceil((proportion * n) / 2);
        //         index = Math.abs(index) - 1;
        //
        //         for (let i = 0; i < n; i++) {
        //             if (i <= index) {
        //                 cards[i].classList.add('cdActive');
        //             } else {
        //                 cards[i].classList.remove('cdActive');
        //             }
        //         }
        //
        //         setActiveIndex(index);
        //         rotateCards();
        //     }
        // };

        const handleResize = () => {
            const windowWidth = window.innerWidth;
            const left = document.querySelector('.cdLeft');
            if (left) {
                left.remove();
                if (windowWidth < 800) {
                    stackArea.insertAdjacentElement('beforebegin', left);
                } else {
                    stackArea.insertAdjacentElement('afterbegin', left);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const cdStyles = {
        center: {
            width: '100%',
            height: 'fit-content',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        cdStackArea: {
            width: '100%',
            height: '220vh',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            // marginTop: '-150px',
        },
        cdLeft: {
            height: '100vh',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            position: 'sticky',
            top: 0,
            boxSizing: 'border-box',
            flexDirection: 'column',
            flexBasis: '66%',
        },
        cdRight: {
            height: '100vh',
            display: 'flex',
            alignItems: isInView ? 'flex-start' : 'center',
            justifyContent: 'center',
            position: 'sticky',
            top: 0,
            flexBasis: '50%',
        },
        cdCard: {
            backgroundColor: 'white',
            width: '594px',
            height: '435px',
            boxSizing: 'border-box',
            padding: '0',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            position: 'absolute',
            top: isInView ? '30%' : '50%',
            left: '50%',
            transition: '0.5s ease-in-out',
            borderRadius: '24px',
            border: '8px solid #F5F3FF',
            boxShadow: '0 25px 50px -12px rgba(76, 29, 149, 0.20)',
        },
    };

    return (
        <div className="container">
            <div ref={stackRef} style={{ height: 1 }} />

            <div style={cdStyles.center}>
                <div style={cdStyles.cdStackArea} className="cd-stack-area">
                    <div style={cdStyles.cdLeft} className="cdLeft">
                        <div className="cards">
                            {images.map((item, index) => (
                                <div
                                    key={index}
                                    className="cdCard"
                                    style={{
                                        ...cdStyles.cdCard,
                                        zIndex: cardData.length - index,
                                    }}
                                >
                                    <img
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'fill',
                                            borderRadius: '12px',
                                        }}
                                        src={item?.image}
                                        alt="image"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div style={cdStyles.cdRight} className="cdRight">
                        <div className="complate-aba-care-slide-content">
                            {cardData.map((item, index) => (
                                <div
                                    key={index}
                                    ref={(el) => (leftRefs.current[index] = el)}
                                    className="complate-aba-care-slide-content-item-wrapper"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setActiveIndex(index);
                                        if (rotateCardsRef.current) {
                                            rotateCardsRef.current(index);
                                        }
                                    }}
                                >
                                    <div
                                        style={{ backgroundColor: activeIndex === index ? '#A855F7' : '#EEF5FE' }}
                                        className="complate-aba-care-slide-content-item-step"
                                    />

                                    <div className="complate-aba-care-slide-content-item-block">
                                        <h4
                                            style={{
                                                color: activeIndex === index ? '#A855F7' : '#475467',
                                                fontWeight: activeIndex === index ? 700 : 500,
                                            }}
                                            className="complate-aba-care-slide-content-item-title"
                                        >
                                            {item.title}
                                        </h4>

                                        <p className="complate-aba-care-slide-content-item-text">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
